import qs from 'qs'
import { inject } from 'tsyringe'
import VueRouter from 'vue-router'
import { containerScoped } from '~/decorators/dependency-container'

@containerScoped()
export default class UrlHistoryService {
  constructor(@inject(VueRouter) private router: VueRouter) {}

  replaceQueryParams(
    queryParams: Record<string, string | string[] | number[] | null | undefined>
  ) {
    if (process.server) {
      return
    }

    const params = {
      ...qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      }),
      ...queryParams
    }
    const url: string = qs.stringify(params, {
      arrayFormat: 'repeat',
      encode: false,
      skipNulls: true
    })
    history.replaceState(null, document.title, `?${url}`)
  }
}
